// extracted by mini-css-extract-plugin
module.exports = {"unsubscribe":"Unsubscribe_unsubscribe__hbqm2","text":"Unsubscribe_text__2v4gt","bg":"Unsubscribe_bg__gpBgH"};